import React, { useState, useMemo, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import useHttpService from "../../services/HttpService";
// Use Socket io - import
import io from "socket.io-client";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Welcome from "../onboarding/Welcome";
import Steps from "../onboarding/Steps";
import Dashboard from "../dashboard/Dashboard";
import Settings from "../dashboard/Settings";
import Tickets from "../dashboard/Tickets";
import WebForm from "../dashboard/Webform";
import mqtt from "precompiled-mqtt";

import ReactGa from "react-ga";

import { SharedDataContext, DataSocketContext } from "./UseContext";

/* START $$$$$$$$$$$$$$$$$$$$$$$$$$$$$ */
import {
  SOCKET,
  LOCAL_API,
  APISID,
  MQTT_SERVER
} from "../../constants/Constants";
import Axios from "axios";
import { useKeycloak } from "@react-keycloak/web";
import keycloak from "../../keycloak";

// const socket = io(SOCKET.BASE_URL);
const mqttClient = mqtt.connect("wss://" + MQTT_SERVER + "/mqtt");
/* END $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ */

const Routing = props => {
  const {
    t,
    changeLang,
    defaultLang,
    isLogged,
    handleChooseService,
    checkedServices,
    activeServices,
    selectServiceRef,
    handleSimulateChooseServices,
    containerWidth,
    i18n
  } = props;
  //chechsession request
  const {
    send: sendRequestCheckSession,
    data: sessionResponse,
    loading: onLoadingSession,
    error: onErrorSession
  } = useHttpService("CHECK_SESSION");

  const { keycloak, initialized } = useKeycloak();

  const [user, setUser] = useState(null);
  const hasMount = useRef(false);
  const unmounted = useRef(false);
  const [stateCheckSession, setStateCheckSession] = useState("loading");

  const [sharedDataContext, setSharedDataContext] = useState({
    socketConnected: false,
    userLogged: false,
    status: 0,
    currentUser: {},
    notification: {
      active: false, // false , true
      status: "", // success , danger,
      content: { title: "", msg: "" }
    },
    conversational: {
      page: 0
    }
  });

  const providerSharedDataContext = useMemo(
    () => ({ sharedDataContext, setSharedDataContext }),
    [sharedDataContext, setSharedDataContext, initialized]
  );

  const path = window.location.pathname + window.location.search;

  const lui = async () => {
    const ui = await keycloak.loadUserInfo();
    // console.log(ui)
  };
  const lup = async () => {
    const up = await keycloak.loadUserProfile();
    setSharedDataContext({ ...sharedDataContext, currentUser: up });
    updateUserInfo(up);
  };
  useEffect(() => {
    if (initialized) {
      console.log(keycloak);
      lui().catch(console.error);
      lup().catch(console.error);
    }
  }, [initialized]);

  //Initialize react google analytics
  useEffect(() => {
    // ReactGa.initialize("UA-171570583-1");
    // ReactGa.pageview(window.location.pathname + window.location.search);
  }, [path]);

  //check session useEffect
  useEffect(() => {
    if (!hasMount.current) {
      // componentDidMount

      // socket.on("connect", () => {
      //   setSharedDataContext({ ...sharedDataContext, socketConnected: true });
      // });

      mqttClient.on("connect", () => {
        // console.log("mqtt connect");
        mqttClient.subscribe("rightdesk_api_response/#", err => {
          // console.log("mqtt subscribing");
          if (!err) {
            console.log(
              "mqtt subscribed to rightdesk_api_response/" + keycloak.realm
            );
            setSharedDataContext({
              ...sharedDataContext,
              socketConnected: true
            });
          } else console.log("mqtt error subscription " + err);
        });
      });
      mqttClient.on("message", (topic, message) => {
        // console.log(__filename, "mqtt message on topic: "+topic)
        // const msg = JSON.parse(message.toString())
        // console.log(topic, msg.process, msg.data);
        // console.log(topic);
      });

      // checkSession();
      //console.log("componentDidMount");
      hasMount.current = true;
    }
    return () => {
      // socket.on("disconnect", () => {
      //   //  console.log("Disconnected socket");
      //   setSharedDataContext({
      //     ...sharedDataContext,
      //     socketConnected: false
      //   });
      // });
      mqttClient.end();
      setSharedDataContext({
        ...sharedDataContext,
        socketConnected: false
      });
      unmounted.current = true;
      // componentWillUnmount
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (!unmounted.current) {
  //     if (!onLoadingSession && onErrorSession) {
  //       setStateCheckSession("error");
  //     }
  //     if (sessionResponse) {
  //       if (sessionResponse.status === 200) {
  //         // user session is ok
  //         // set user session
  //         sessionResponse.user = sessionResponse.data;
  //         sessionResponse.user.apisid = APISID;
  //         sessionResponse.user.userid = sessionResponse.data.id;
  //         updateUserInfo(sessionResponse.user);
  //         //updatecontext(sessionResponse.user);
  //       } else {
  //         //  window.location = LOCAL_API.LOGOUT;
  //       }
  //     }
  //   }
  // }, [sessionResponse]);

  useEffect(() => {
    if (typeof sharedDataContext.currentUser.subdomain !== "undefined") {
      let currentUser = sharedDataContext.currentUser;
      let userInfo = {
        user_id: currentUser.id,
        fullname: currentUser.firstName + " " + currentUser.lastName,
        email: currentUser.email,
        subdomain: currentUser.subdomain
      };
      //window.hj("identify", currentUser.id, userInfo);
    }
  }, [sharedDataContext.currentUser]);

  // useEffect(() => {
  //   socket.on("connect", () => {
  //     setSharedDataContext({ ...sharedDataContext, socketConnected: true });
  //   });
  //   // socket.on("disconnect", () => {
  //   //   // console.log("Disconnected socket");
  //   //   setSharedDataContext({
  //   //     ...sharedDataContext,
  //   //     socketConnected: false
  //   //   });
  //   // });
  //   return () => {
  //     socket.on("disconnect", () => {
  //       //  console.log("Disconnected socket");
  //       setSharedDataContext({
  //         ...sharedDataContext,
  //         socketConnected: false
  //       });
  //     });
  //   };
  // });
  function checkSession() {
    sendRequestCheckSession();
  }

  function updateUserInfo(user) {
    setUser(user);
    setSharedDataContext({
      ...sharedDataContext,
      currentUser: user,
      userLogged: true,
      defaultLang: defaultLang,
      socketConnected: true,
      status: 0
    });
  }

  // console.log(" ROUTING RENDER",sharedDataContext);
  let haveRights =
    keycloak.hasRealmRole("owner") ||
    keycloak.hasRealmRole("admin") ||
    keycloak.hasResourceRole("rightdesk_admin", "rightdesk") ||
    keycloak.hasResourceRole("rightdesk_manager", "rightdesk") ||
    keycloak.hasResourceRole("rightdesk_user", "rightdesk");
  /*
    sharedDataContext?.currentUser?.is_owner ||
    sharedDataContext?.currentUser?.full_rights?.length;*/
  return (
    <DataSocketContext.Provider value={mqttClient}>
      <Router>
        <SharedDataContext.Provider value={providerSharedDataContext}>
          {user ? (
            <Switch>
              <Route exact path="/">
                <Welcome
                  haveRights={haveRights}
                  t={t}
                  changeLang={changeLang}
                  defaultLang={defaultLang}
                  kind="onboard"
                  isLogged={false}
                  containerWidth={containerWidth}
                />
              </Route>
              <Switch>
                <Route path="/onboard">
                  <Steps
                    haveRights={haveRights}
                    t={t}
                    changeLang={changeLang}
                    defaultLang={defaultLang}
                    kind="app"
                    isLogged={isLogged}
                    handleChooseService={handleChooseService}
                    checkedServices={checkedServices}
                    activeServices={activeServices}
                    selectServiceRef={selectServiceRef}
                    handleSimulateChooseServices={handleSimulateChooseServices}
                    containerWidth={containerWidth}
                  />
                </Route>
                <Route path="/dashboard">
                  <Dashboard
                    haveRights={haveRights}
                    t={t}
                    changeLang={changeLang}
                    defaultLang={defaultLang}
                    kind="dashboard"
                    isLogged={isLogged}
                    i18n={i18n}
                  />
                </Route>
                <Route path="/webform">
                  <WebForm
                    haveRights={haveRights}
                    t={t}
                    changeLang={changeLang}
                    defaultLang={defaultLang}
                    kind="webform"
                    isLogged={isLogged}
                    i18n={i18n}
                  />
                </Route>
                <Route path="/tickets">
                  <Tickets
                    haveRights={haveRights}
                    t={t}
                    changeLang={changeLang}
                    defaultLang={defaultLang}
                    kind="tickets"
                    isLogged={isLogged}
                    i18n={i18n}
                  />
                </Route>
                <Route path="/settings">
                  <Settings
                    haveRights={haveRights}
                    t={t}
                    changeLang={changeLang}
                    defaultLang={defaultLang}
                    kind="settings"
                    isLogged={isLogged}
                    i18n={i18n}
                  />
                </Route>
              </Switch>
            </Switch>
          ) : (
            <div></div>
          )}
        </SharedDataContext.Provider>
      </Router>
    </DataSocketContext.Provider>
  );
};

Routing.propTypes = {
  t: PropTypes.func //, //.isRequired,
  // changeLang: PropTypes.func, //, //.isRequired,
  // defaultLang: PropTypes.shape({}), //, //.isRequired,
  // isLogged: PropTypes.bool, //, //.isRequired,
  // containerWidth: PropTypes.number, //, //.isRequired,
  // handleChooseService: PropTypes.func, //, //.isRequired,
  // checkedServices: PropTypes.objectOf({}), //, //.isRequired,
  // activeServices: PropTypes.arrayOf([]), //, //.isRequired,
  // selectServiceRef: PropTypes.func, //, //.isRequired,
  // handleSimulateChooseServices: PropTypes.func, //, //.isRequired
};

export default Routing;
